import { render, staticRenderFns } from "./EbtoClaim.vue?vue&type=template&id=0cd3adb5&scoped=true"
import script from "./EbtoClaim.vue?vue&type=script&lang=ts"
export * from "./EbtoClaim.vue?vue&type=script&lang=ts"
import style0 from "./EbtoClaim.vue?vue&type=style&index=0&id=0cd3adb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd3adb5",
  null
  
)

export default component.exports